import React, { useState } from "react";
import { Link } from "react-router-dom";
import WholisticLogo from "../../images/WholisticLogo.jpg"; // Add your logo

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      {/* Logo Section */}
      <div className="logo">
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <img src={WholisticLogo} alt="Wholistic Home-Based Care Logo" />
        </Link>
      </div>

      {/* Navigation Links - Centered */}
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
        <li><Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link></li>
        <li><Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link></li>
        <li><Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link></li>
        <li><Link to="/team" onClick={() => setMenuOpen(false)}>Team</Link></li>
        <li><Link to="/testimonials" onClick={() => setMenuOpen(false)}>Testimonials</Link></li>
        {/* <li><Link to="/landing" onClick={() => setMenuOpen(false)}>Landing</Link></li> */}
        <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
      </ul>

      {/* Mobile Menu Button */}
      <div className="menu-toggle" onClick={toggleMenu}>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
      </div>
    </nav>
  );
}

export default Navbar;
